import Vue from 'vue'
import { router } from './components/_helpers';
import App from './App'
import { store } from './components/_store'

import VueAnalytics from 'vue-analytics'
import VueTagManager from 'vue-tag-manager'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas, faCoffee, faBolt, faExclamation, faHourglass, faBan, faThumbsDown, faPlus, faSpinner, faBookmark, faTimes, faRss, faEnvelope, faSearch, faStar, faChartBar, faChevronLeft, faChevronRight, faTags, faTrashAlt, faUpload} from '@fortawesome/free-solid-svg-icons'
import { far, faImage, faSmile, faClock, faSquare, faCheckSquare, faNewspaper, faComment, faCopy } from '@fortawesome/free-regular-svg-icons'
import { fab, faPinterestP, faLinkedinIn, faTwitter, faFacebookF, faInstagram, faChrome, faFirefox, faSafari, faAndroid, faApple, faBuffer} from '@fortawesome/free-brands-svg-icons'
import { ritetagHashtagSuggestion } from './icons/hashtag-suggestion'
import { ritetagHashtagSet } from './icons/hashtag-set'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { VueMasonryPlugin } from 'vue-masonry'

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Sentry.init({
  dsn: 'https://090e69837fe345d5a7a33cb5ce6d2653@sentry.io/1234914',
  integrations: [new Integrations.Vue({Vue, attachProps: true})],
});

library.add(
    fas,
    far,
    fab,
    faImage,
    faSmile,
    faClock,
    faCoffee,
    faTwitter,
    faFacebookF,
    faInstagram,
    faPinterestP,
    faLinkedinIn,
    faBolt,
    faExclamation,
    faHourglass,
    faBan,
    faThumbsDown,
    faSquare,
    faCheckSquare,
    faPlus,
    faSpinner,
    faBookmark,
    faTimes,
    faChrome,
    faFirefox,
    faSafari,
    faAndroid,
    faApple,
    faNewspaper,
    faComment,
    faRss,
    faEnvelope,
    faSearch,
    faStar,
    faChartBar,
    faChevronLeft,
    faChevronRight,
    faTags,
    faTrashAlt,
    faCopy,
    faUpload,
    faBuffer,
    ritetagHashtagSuggestion,
    ritetagHashtagSet
)

import Datetime from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import vueNumeralFilterInstaller from 'vue-numeral-filter'

Vue.use(vueNumeralFilterInstaller)
Vue.use(Datetime)
Vue.use(VueAnalytics, {
  id: 'UA-18806456-13',
  router
})

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueTagManager, {
  gtmId: 'GTM-KWJKBC'
})

// Vue Bootstrap
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/scss/bootstrap.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueTour from 'vue-tour';
require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour);

// CSS Add ons
import ToggleButton from 'vue-js-toggle-button'
// Other addons
import Clipboard from 'v-clipboard'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'
import moment from 'moment'

Vue.use(BootstrapVue)
Vue.use(ToggleButton)
Vue.use(Clipboard)
Vue.use(Notifications, { velocity })
Vue.use(VueMasonryPlugin)

Vue.filter('formatDate', value => {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
})
Vue.filter('formatToShortDate', value => {
  if (value) {
    return moment(String(value)).format('MMM Do YYYY')
  }
})
Vue.filter('capitalize', value => {
  if (value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
})
Vue.filter('round', (value, precision) => {
  if (value) {
    const p = Math.pow(10, precision);
    return Math.floor(value * p) / p
  }
})
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
